import React from "react";
import axios from "axios";
import { isFinesSortType } from "../HostSystemItemSortControl";
import { HostSystemItemSortType } from "@tlc/ls2pac/dto/HostSystemItemSortType";
import { LoaderFunctionArgs } from "react-router-dom";
import { GetFeesReturn } from "./finesLoader";
import { convertPenniesToCurrency } from "@tlc/ls2pac/components/AccountMenu";
import { HostSystemItemView } from "@tlc/ls2pac/dto/HostSystemItemView";

export const getChildFinesSortable = async (
  id: string,
  page: number,
  count: number,
  sortType: HostSystemItemSortType,
  refreshToken: number,
): Promise<GetFeesReturn> => {
  const response = await axios.get(
    `/fees/child/${id}/${page * count}/${count}/${sortType}?_=${refreshToken}`,
  );
  return response.data;
};

export const childFinesLoader = async ({
  request,
  params,
}: LoaderFunctionArgs) => {
  const id = params.id!;
  const url = new URL(request.url);
  const sortParam = url.searchParams.get("sort");
  const sort =
    sortParam && isFinesSortType(sortParam)
      ? sortParam
      : HostSystemItemSortType.OutDate;

  const page = url.searchParams.has("page")
    ? parseInt(url.searchParams.get("page")!)
    : 0;

  const pageSize = url.searchParams.has("size")
    ? parseInt(url.searchParams.get("size")!)
    : 10;

  const refreshToken = Date.now();

  const getTotalFees = (fees: HostSystemItemView[]) => {
    const total = fees.reduce((acc, curr) => {
      const fee = curr.fee || 0;
      return acc + fee;
    }, 0);

    console.log("total: ", total);
    return convertPenniesToCurrency(total);
  };

  const dataPromise = await Promise.all([
    axios.get(
      `/fees/child/${id}/${
        page * pageSize
      }/${pageSize}/${sort}?_=${refreshToken}`,
    ),
    axios.get(
      `/fees/child/${id}/${0 * 10000}/${10000}/${sort}?_=${refreshToken}`,
    ),
  ])
    .then(([feesRes, totalFeesRes]) => ({
      sort,
      page,
      pageSize,
      fees: feesRes.data.fees,
      childTotalFees: getTotalFees(totalFeesRes.data.fees),
      childFeesTotalCount: feesRes.data.totalFees,
      refreshToken,
    }))
    .catch((error) => {
      console.error("Error fetching fines", error);
      if (axios.isAxiosError(error) && error.response?.status === 403) {
        throw new Response("Forbidden", { status: 403 });
      }
      throw error;
    });

  return { data: dataPromise, pageSize: pageSize }; // need synchronous pageSize for skeletons array in React.Suspense fallback
};
